import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { OFFERS } from "../../data/salon";
import { faPercent, toFa, toman } from "../../lib/format";

/** Counts down to the end of the current month. */
function useMonthCountdown() {
  const target = () => {
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth() + 1, 1).getTime();
  };

  const [left, setLeft] = useState(() => target() - Date.now());

  useEffect(() => {
    const t = setInterval(() => setLeft(Math.max(0, target() - Date.now())), 1000);
    return () => clearInterval(t);
  }, []);

  const s = Math.floor(left / 1000);
  return [
    { v: Math.floor(s / 86400), l: "روز" },
    { v: Math.floor((s % 86400) / 3600), l: "ساعت" },
    { v: Math.floor((s % 3600) / 60), l: "دقیقه" },
    { v: s % 60, l: "ثانیه" },
  ];
}

export default function Promo() {
  const units = useMonthCountdown();
  const offer = OFFERS[0];

  return (
    <section className="promo">
      <div className="wrap wrap--wide promo__grid">
        <div className="promo__media">
          <Photo src={offer.photo} ratio="4 / 5" scrub tint="warm" />
        </div>

        <div className="promo__copy">
          <span className="eyebrow eyebrow--violet">{offer.latin}</span>
          <h2 className="promo__title">{offer.title}</h2>

          <p className="promo__value">
            {offer.kind === "percent" ? faPercent(offer.value) : toman(offer.value)}
            <span> تخفیف</span>
          </p>

          <p className="promo__body">{offer.body}</p>

          <div className="promo__clock" role="timer" aria-label="زمان باقی‌مانده">
            {units.map((u) => (
              <div className="promo__unit" key={u.l}>
                <span className="promo__num">{toFa(String(u.v).padStart(2, "0"))}</span>
                <span className="promo__lab">{u.l}</span>
              </div>
            ))}
          </div>

          <Link to="/offers" className="btn btn--violet">استفاده از پیشنهاد</Link>
        </div>
      </div>
    </section>
  );
}
